<template>
    <div id="lt-yantr-v2" class="daily-mortgage-rate-trends-v2">
        <div v-if="myltexp == 0" class="container-width">
            <div class="header-sec">
                <h2 class="title-text">{{ heading }}</h2>
                <div class="filter-sec">
                    <drop-down
                        v-model="CreditScore"
                        :label="labelRatesForCreditScore"
                        :options="CreditScoreList"
                        :tooltip-link="CreditScoreTooltip"
                        class-value="creditScore"
                        @input="fetchChartData()"
                    />
                    <drop-down
                        v-model="ProductType"
                        :label="labelLoanPurpose"
                        :options="MortgageProductTypeList"
                        :tooltip-link="LoanPurposeTooltip"
                        @input="fetchChartData()"
                    />
                </div>
            </div>

            <div class="graph-table-wrap">
                <div class="graph-sec">
                    <canvas ref="chart" :width="ChartWidth" :height="ChartHeight"></canvas>
                </div>
                <div class="table-sec">
                    <div class="table-responsive">
                        <table class="table table-br-top">
                            <thead>
                                <tr>
                                    <th width="33%" align="left">Loan Type</th>
                                    <th width="33%" align="center">Avg. APR</th>
                                    <th width="33%" align="right">3 Month Diff.</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="trend in TrendTableData" :key="trend.index">
                                    <td align="left" class="loan-type"><span class="indicator" :class="trend.className"></span>{{ trend.program }}</td>
                                    <td align="center" class="avg-apr">{{ currencyFilterPrecision3(trend.averageApr) }}%</td>
                                    <td align="right" class="day-diff">{{ currencyFilterWithPrecision(trend.month3diff) }}%
                                        <svg v-if="trend.month3diff > 0" class="trend-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#D93551" d="M18.619 11.12a.876.876 0 0 0 0-1.238l-5.99-5.993A.893.893 0 0 0 12 3.625a.873.873 0 0 0-.657.298L5.382 9.88a.875.875 0 0 0 1.237 1.238l4.507-4.504V19.5a.875.875 0 1 0 1.75 0V6.611l4.505 4.507a.876.876 0 0 0 1.238.001Z" /></svg>
                                        <svg v-else-if="trend.month3diff < 0" class="trend-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#08C177" d="M18.615 12.884a.875.875 0 0 1 0 1.237l-5.99 5.993a.885.885 0 0 1-1.252 0l-5.995-5.992a.876.876 0 0 1 1.237-1.238l4.506 4.504V4.503a.875.875 0 0 1 1.75 0v12.889l4.506-4.507a.876.876 0 0 1 1.238-.001Z" /></svg>
                                        <svg v-else class="trend-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48"><path fill="#101F30" fill-rule="evenodd" d="M5.625 24c0-.76.616-1.375 1.375-1.375h34a1.375 1.375 0 1 1 0 2.75H7c-.76 0-1.375-.616-1.375-1.375Z" clip-rule="evenodd" /></svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="btn-sec">
                        <small>{{ DisclaimerText }}</small>
                        <a v-if="!HideCta" class="destination-btn" :href="CtaUrl">{{ DestinationButtonText }}</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- myltexp -->
        <div v-else-if="myltexp == 1" class="container-width mylt-dashboard-calculator mylt-container-width">
            <div class="mortgage-rate-trends-v2">
                <div class="header-sec">
                    <h1 class="title-text">{{ heading }}</h1>
                    <div class="filter-sec">
                        <span class="sub-text">{{ labelRatesForCreditScore }}</span>
                        <drop-down
                            v-model="CreditScore"
                            :options="CreditScoreList"
                            class-value="creditScore"
                            @input="fetchChartData()"
                        />
                    </div>
                </div>

                <div class="graph-table-wrap">
                    <div class="graph-sec">
                        <canvas ref="chart" :width="ChartWidth" :height="ChartHeight"></canvas>
                    </div>
                    <div class="table-sec">
                        <div class="table-responsive">
                            <table class="table table-br-top">
                                <thead>
                                    <tr>
                                        <th width="33%" align="left">Loan Type</th>
                                        <th width="33%" align="center">Avg APR</th>
                                        <th width="33%" align="right">3 Month Diff</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="trend in TrendTableData" :key="trend.index">
                                        <td align="left" class="loan-type"><span class="indicator" :class="trend.className"></span>{{ trend.program }}</td>
                                        <td align="center" class="avg-apr">{{ currencyFilterPrecision3(trend.averageApr) }}%</td>
                                        <td align="right" class="day-diff">{{ currencyFilterWithPrecision(trend.month3diff) }}%
                                            <svg v-if="trend.month3diff > 0" class="trend-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#D93551" d="M18.619 11.12a.876.876 0 0 0 0-1.238l-5.99-5.993A.893.893 0 0 0 12 3.625a.873.873 0 0 0-.657.298L5.382 9.88a.875.875 0 0 0 1.237 1.238l4.507-4.504V19.5a.875.875 0 1 0 1.75 0V6.611l4.505 4.507a.876.876 0 0 0 1.238.001Z" /></svg>
                                            <svg v-else-if="trend.month3diff < 0" class="trend-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#08C177" d="M18.615 12.884a.875.875 0 0 1 0 1.237l-5.99 5.993a.885.885 0 0 1-1.252 0l-5.995-5.992a.876.876 0 0 1 1.237-1.238l4.506 4.504V4.503a.875.875 0 0 1 1.75 0v12.889l4.506-4.507a.876.876 0 0 1 1.238-.001Z" /></svg>
                                            <svg v-else class="trend-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48"><path fill="#101F30" fill-rule="evenodd" d="M5.625 24c0-.76.616-1.375 1.375-1.375h34a1.375 1.375 0 1 1 0 2.75H7c-.76 0-1.375-.616-1.375-1.375Z" clip-rule="evenodd" /></svg>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="btn-sec">
                            <small>{{ DisclaimerText }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Chart from 'chart.js';
    import Accounting from 'accounting';
    import BaseMixin from '~/mixin/base-mixin';
    import DropDown from './components/drop-down.vue';
    import LoanTypeList from '~/constants/loan-type-list';
    import CreditScoreList from '~/constants/credit-score-list';
    import DailyMortgageRatesService from '~/services/daily-mortgage-trend-service';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import wwwUrlEnv from '~/helpers/www-url-env';

    export default {
        props: {
            heading: {
                default: 'Mortgage Rate Trends',
            },
            labelRatesForCreditScore: {
                default: 'Showing Rates For Credit Score:',
            },
            creditScore: {
                default: '700-739',
            },
            creditScoreTooltip: {
                default: DefaultTooltip.CreditScore,
            },
            labelLoanPurpose: {
                default: 'Loan Purpose:',
            },
            productType: {
                default: 'purchase',
            },
            loanProgramType: {
                default: '',
            },
            loanPurposeTooltip: {
                default: DefaultTooltip.Mortgage,
            },
            destinationLinkOrId: {
                default: 'wp-mortgage',
            },
            destinationButtonText: {
                default: 'See Offers',
            },
            disclaimerText: {
                default: 'Terms and Conditions apply. NMLS#1136',
            },
            ctaRedirectLink: {
                default: 'wp-refinance',
            },
            hideCta: {
                default: 'false',
            },
            myltexp: {
                default: '0',
            },
            ctaUrl: {
                default: `${wwwUrlEnv.getWWWURL()}/redirect/offers?id=wp-mortgage`,
            },
            icodeRcode: {
                default: () => ({}),
            },
        },
        data() {
            return {
                CreditScore: this.creditScore,
                CreditScoreList: CreditScoreList.dailyMortgageTrend,
                CreditScoreTooltip: parseInt(this.hideTooltip, 10) ? '' : this.creditScoreTooltip,
                ProductType: this.productType,
                MortgageProductTypeList: LoanTypeList.ProductTypeList,
                LoanPurposeTooltip: parseInt(this.hideTooltip, 10) ? '' : this.loanPurposeTooltip,
                DestinationLinkOrId: this.destinationLinkOrId,
                CtaUrl: this.ctaUrl,
                DestinationButtonText: this.destinationButtonText,
                ChartWidth: 525,
                ChartHeight: 300,
                TrendTableData: {},
                DisclaimerText: this.disclaimerText,
                HideCta: this.hideCta === 'true',
                chartData: {
                    labels: [],
                    datasets: [
                        {
                            label: '30 Year Fixed',
                            fill: false,
                            lineTension: 0,
                            borderColor: '#08C177',
                            pointBorderWidth: 10,
                            pointHitRadius: 5,
                            pointHoverRadius: 4,
                            pointBackgroundColor: '#08C177',
                            pointBorderColor: '#08C177',
                            pointHoverBackgroundColor: '#08C177',
                            data: [],
                        },
                        {
                            label: '15 Year Fixed',
                            fill: false,
                            lineTension: 0,
                            borderColor: '#101F30',
                            pointBorderWidth: 10,
                            pointHitRadius: 5,
                            pointHoverRadius: 4,
                            pointBackgroundColor: '#101F30',
                            pointBorderColor: '#101F30',
                            pointHoverBackgroundColor: '#101F30',
                            data: [],
                        },
                        {
                            label: '5/1 ARM',
                            fill: false,
                            lineTension: 0,
                            borderColor: '#FF704D',
                            pointBorderWidth: 10,
                            pointHitRadius: 5,
                            pointHoverRadius: 4,
                            pointBackgroundColor: '#FF704D',
                            pointBorderColor: '#FF704D',
                            pointHoverBackgroundColor: '#FF704D',
                            data: [],
                        },
                    ],
                },
                options: {
                    elements: {
                        point: {
                            radius: 0,
                        },
                    },
                    scaleShowVerticalLines: false,
                    legend: {
                        display: false,
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    chartArea: {
                        backgroundColor: '#fff',
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                min: 2.5,
                                stepSize: 0.5,
                                fontColor: '#454545',
                                callback(value) {
                                    return value > 0 ? `${value.toFixed(1)}%` : 0.0;
                                },
                            },
                            gridLines: {
                                color: '#c6cdd0',
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                autoSkip: false,
                                maxRotation: 0,
                                minRotation: 0,
                                fontColor: '#454545',
                                padding: 8,
                            },
                            afterTickToLabelConversion(data) {
                                const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                const xLabels = data.ticks;
                                xLabels.forEach((labels, i) => {
                                    if (labels.split('/')[1].trim().toString() === '1') {
                                        xLabels[i] = monthNames[labels.split('/')[0] - 1];
                                    } else {
                                        xLabels[i] = '';
                                    }
                                });
                            },
                            gridLines: false,
                        }],
                    },
                    tooltips: {
                        mode: 'index',
                        position: 'nearest',
                        titleFontStyle: 'bold',
                        callbacks: {
                            title(tooltipItems, data) {
                                return data.labels[tooltipItems[0].index];
                            },
                            label(tooltipItem, data) {
                                const value = ` ${data.datasets[tooltipItem.datasetIndex].label}: ${data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]}`;
                                return `${value}%`;
                            },
                        },
                    },
                },
                chart: '',
                LoanProgramType: this.loanProgramType,
                CtaRedirectLink: this.ctaRedirectLink,
                IcodeRcode: this.icodeRcode,
            };
        },
        methods: {
            generateRedirectUrl() {
                this.DestinationLinkOrId = null;
                this.$nextTick(() => {
                    if (this.ProductType === 'refinance') {
                        this.DestinationLinkOrId = this.CtaRedirectLink;
                    } else {
                        this.DestinationLinkOrId = this.destinationLinkOrId;
                    }
                    this.CtaUrl = `${this.setDestinationBaseURL().replace('https://www.lendingtree.com', wwwUrlEnv.getWWWURL())}`;

                    if (this.IcodeRcode.icode !== undefined) {
                        this.CtaUrl = `${this.CtaUrl}&icode=${this.IcodeRcode.icode}`;
                    }
                    if (this.IcodeRcode.rcode !== undefined) {
                        this.CtaUrl = `${this.CtaUrl}&rcode=${this.IcodeRcode.rcode}`;
                    }
                });
            },
            calculateMonthRange() {
                const date = new Date();
                const MonthRange = [];
                for (let month = 3; month >= 0; month--) {
                    const d = new Date(date.getYear(), date.getMonth() + 1 - month, 0);
                    MonthRange.push(d.getMonth() + 1);
                }
                return MonthRange;
            },
            calculateChartData(LastDate) {
                this.chartData.labels = [];
                const date = new Date(LastDate);
                const previosDate = new Date(LastDate);
                previosDate.setMonth(previosDate.getMonth() - 3);
                for (let month = 3; month >= 0; month--) {
                    const dateOld = new Date(date.getFullYear(), date.getMonth() + 1 - month, 0);
                    const d = new Date(Date.UTC(dateOld.getFullYear(), dateOld.getMonth() + 1, 0));
                    for (let day = 1; day <= d.getUTCDate(); day++) {
                        if (d.getMonth() + 1 < previosDate.getMonth() + 1 && d.getFullYear() === previosDate.getFullYear()) {
                            continue;
                        }
                        if (d.getMonth() + 1 > date.getMonth() + 1 && d.getFullYear() === date.getFullYear()) {
                            continue;
                        }
                        if (day < previosDate.getUTCDate() && d.getMonth() + 1 === previosDate.getMonth() + 1) {
                            continue;
                        }
                        if (day > date.getUTCDate() && d.getMonth() + 1 === date.getMonth() + 1) {
                            continue;
                        }
                        this.chartData.labels.push(`${d.getMonth() + 1}/${day}/${d.getFullYear()}`);
                    }
                }
            },
            customizeTrendResult(mortgageTrends) {
                const MortgageTrend = {};
                const SkippedTrend = {};
                const Programs = ['30 Year Fixed', '15 Year Fixed', '5/1 ARM'];

                let lastDayDate = '';
                let lowestValue = '0';

                if (mortgageTrends.length) {
                    const monthRange = this.calculateMonthRange();
                    lastDayDate = mortgageTrends[0].qFormCompleteDate;

                    mortgageTrends.forEach((trendValues) => {
                        const trendDate = new Date(trendValues.qFormCompleteDate);
                        let loanProgram = '';
                        const currentTrend = `${trendDate.getMonth() + 1}/${trendDate.getUTCDate()}/${trendDate.getFullYear()}`;

                        switch (trendValues.loanProgramName) {
                            case '30 Year Fixed':
                            case 'VA 30 Year Fixed':
                            case 'FHA 30 Year Fixed':
                                loanProgram = '30 Year Fixed';
                                break;

                            case '15 Year Fixed':
                            case 'VA 15 Year Fixed':
                            case 'FHA 15 Year Fixed':
                                loanProgram = '15 Year Fixed';
                                break;

                            case '30 Yr 5/1 ARM':
                            case 'VA 30 Yr 5/1 ARM':
                            case 'FHA 30 Yr 5/1 ARM':
                                loanProgram = '5/1 ARM';
                                break;
                        }

                        if (monthRange.indexOf(trendDate.getMonth() + 1) > -1) {
                            if (!MortgageTrend[loanProgram]) {
                                MortgageTrend[loanProgram] = {};
                            }
                            if (loanProgram) {
                                if (!MortgageTrend[loanProgram][currentTrend]) {
                                    MortgageTrend[loanProgram][currentTrend] = trendValues.averageInterestRate;
                                    if (lastDayDate < trendValues.qFormCompleteDate) {
                                        lastDayDate = trendValues.qFormCompleteDate;
                                    }
                                }
                            }
                        }
                        if (loanProgram) {
                            if (!SkippedTrend[loanProgram]) {
                                SkippedTrend[loanProgram] = {};
                            }

                            if (!SkippedTrend[loanProgram][currentTrend]) {
                                SkippedTrend[loanProgram][currentTrend] = trendValues.averageInterestRate;
                            }
                        }
                    });
                    this.calculateChartData(lastDayDate);
                    const trendDates = this.chartData.labels;
                    const classArray = ['lt-green-bg', 'lt-blue-deep-bg', 'lt-electric-salmon-bg'];
                    const currentDate = this.calculatePreviousDates('current', 0, lastDayDate);
                    const previousMonth = this.calculatePreviousDates('month', 3, lastDayDate);
                    const trendTableData = {};
                    Programs.forEach((currentProgram, pIndex) => {
                        const programDetails = MortgageTrend[currentProgram] || {};
                        let previousData = 0;
                        this.chartData.datasets[pIndex].data = [];

                        trendDates.forEach((date) => {
                            if (!(date in programDetails) && date === previousMonth) {
                                previousData = this.searchPreviousTrend(SkippedTrend[currentProgram], date);
                                programDetails[date] = previousData;
                            } else if (!(date in programDetails) && date !== previousMonth) {
                                programDetails[date] = previousData;
                            }
                            if (lowestValue > programDetails[date].toFixed(2) || lowestValue === '0') {
                                lowestValue = programDetails[date].toFixed(2);
                            }
                            this.chartData.datasets[pIndex].data.push(programDetails[date].toFixed(2));
                            previousData = programDetails[date];
                        });

                        if (trendTableData[pIndex] === undefined) trendTableData[pIndex] = [];
                        trendTableData[pIndex] = {
                            program: currentProgram,
                            className: classArray[pIndex],
                            averageApr: programDetails[currentDate].toFixed(2),
                            month3diff: (programDetails[currentDate] - programDetails[previousMonth]).toFixed(2),
                        };
                    });
                    this.TrendTableData = {};
                    this.TrendTableData = trendTableData;
                } else {
                    this.chartData.labels = [];
                    for (let program = 0; program < 3; program++) {
                        this.chartData.datasets[program].data = [];
                    }
                    this.TrendTableData = {};
                }
                this.chart.config.options.scales.yAxes[0].ticks.min = parseFloat(lowestValue).toFixed(0) - 0.5;
                this.chart.update();
            },
            fetchChartData() {
                const { ProductType } = this;
                DailyMortgageRatesService.getDailyMortgageRates(ProductType, this.CreditScore, this.LoanProgramType).then((trends) => {
                    this.customizeTrendResult(trends);
                });
                this.generateRedirectUrl();
            },
            currencyFilterPrecision3(figure) {
                return Accounting.formatNumber(Math.abs(figure), { precision: 3 });
            },
            currencyFilterWithPrecision(figure) {
                return Accounting.formatNumber(Math.abs(figure), { precision: 2 });
            },
            calculatePreviousDates(type, number, lastDate) {
                const now = new Date(lastDate);
                if (type === 'date') {
                    now.setUTCDate(now.getUTCDate() - number);
                }
                if (type === 'month') {
                    now.setMonth(now.getMonth() - number);
                }
                return `${now.getMonth() + 1}/${now.getUTCDate()}/${now.getFullYear()}`;
            },
            searchPreviousTrend(trendArray, trend) {
                const now = new Date(trend);
                const searchedDate = new Date(trend);
                if (trendArray) {
                    const trendLength = Object.keys(trendArray).length;
                    for (let nextDate = 0; nextDate < trendLength; nextDate++) {
                        const month = now.getUTCDate() > searchedDate.getUTCDate() ? now.getMonth() : now.getMonth() + 1;
                        const currentDate = `${month}/${now.getUTCDate()}/${now.getFullYear()}`;
                        now.setUTCDate(now.getUTCDate() - 1);
                        if (trendArray[currentDate]) {
                            return trendArray[currentDate];
                        }
                    }
                }
                return 0;
            },
        },
        mounted() {
            this.chart = new Chart(this.$refs.chart, {
                type: 'line',
                data: this.chartData,
                options: this.options,
            });
            this.fetchChartData();
            Chart.pluginService.register({
                beforeDraw(chart) {
                    if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
                        const { ctx } = chart.chart;
                        const { chartArea } = chart;
                        ctx.save();
                        ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
                        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                        ctx.restore();
                    }
                },
            });
            this.IcodeRcode = this.getRcodeIcode();
        },
        watch: {
            'chartData.labels': function () {
                this.chart?.update();
            },
            'chartData.datasets': function () {
                this.chart?.update();
            },
        },
        components: {
            DropDown,
        },
        mixins: [BaseMixin],
    };

    window.addEventListener('orientationchange', () => {
        const chartTooltipElment = document.getElementById('chartjs-tooltip');
        if (chartTooltipElment !== null && typeof chartTooltipElment !== 'undefined') {
            chartTooltipElment.style.opacity = 0;
        }
    }, false);
</script>
<style src="../../assets/styles/v2/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
<style src="../../assets/styles/v2/mylt-dashboard-calculator.scss" lang="scss"></style>
